export function selectStatus(state) {
  return state.status;
}

export function selectIsFetchingChannels(state) {
  return state.status.isFetchingChannels;
}
